export const routes = {
  getSettings: () => `/shared/settings`,
};
